import styled, { css } from 'styled-components'
import { color } from '../globalStyles'

export const Statement = styled.span`
  font-size: 1.4rem;
  font-weight: 300;
`
const TitleBorder = css`
  position: relative;
  padding-bottom: 0.5em;

  &:after {
    content: '';
    display: block;
    width: 5rem;
    border-bottom: 2px solid ${color.primary};
    left: 50%;
    top: 100%;
    position: absolute;
    transform: translateX(-50%);
  }
`
const mixin = {
  titleBorder: css`
    ${props => (props.borderBottom ? TitleBorder : '')};
  `,
  margin: css`
    margin-bottom: ${props => (props.noMargin ? 0 : '1em')};
  `
}
export const H1 = styled.h1`
  ${mixin.titleBorder};
`
export const H2 = styled.h2`
  ${mixin.titleBorder};
`
export const H3 = styled.h3`
  ${mixin.titleBorder} ${mixin.margin};
`
export const H4 = styled.h4`
  ${mixin.titleBorder} ${mixin.margin};
`
export const H5 = styled.h5`
  ${mixin.titleBorder} ${mixin.margin} font-weight: 400;
`
export const H6 = styled.h6`
  ${mixin.titleBorder} ${mixin.margin};
`



// WEBPACK FOOTER //
// ./src/components/type.js